import type { ApolloClient } from '@apollo/client';
import {
  MetamaskAccessCodeQueryDocument,
  MetamaskAccessCodeQueryQueryResult,
} from '../MetamaskAuthButton/useMetamaskButton/graphql/MetamaskAccessCodeQuery.generated';

type Args = { client: ApolloClient<object>; site: Site; address: string };

const getAccessCode = async ({ client, address, site }: Args) => {
  const res = (await client.query({
    query: MetamaskAccessCodeQueryDocument,
    variables: {
      site,
      address,
    },
  })) as MetamaskAccessCodeQueryQueryResult;

  return res.data?.userManagement?.metamaskAccessCode?.accessCode;
};

export default getAccessCode;
